import React from "react";
import DownloadExample from "./download_example";
import { empty_file, upload_file } from "../texts/fill";
import { useImportFile } from "../hook/use_import_file";
import "./FileHandler.css";

const FileHandler = () => {
    const { handleImport, error, loading } = useImportFile();
    const fileInputRef = React.useRef(null);
    const acceptFileTypes = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

    return (
        <div className="file-handler">
            <div className="file-upload-card">
                <DownloadExample />
                <div>
                    <label className="upload-button">
                        {upload_file}
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleImport}
                            accept={acceptFileTypes}
                        />
                        {loading && <span className="spinner-border spinner-border-sm" role="status" />}
                    </label>
                    {error && <div className="alert alert-danger error">{empty_file} </div>}
                </div>
            </div>
        </div>
    );
};

export default FileHandler;
